export default __webpack_public_path__ + "static/media/42.bce2c5c7.jpg";